export default ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var model = $parse(attrs.gwQuickQuoteVinUpload);
            var modelSetter = model.assign;

            element.bind('change', function () {
                scope.$apply(function () {
                    modelSetter(scope, element[0].files[0]);
                });
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/pa/directives/VinUpload/VinUpload.js
// module id = 2193
// module chunks = 0